module.exports = __webpack_public_path__ + "media/images/live-session-card-default-7ffe435a.jpg";